import React from 'react';

import { DateValue } from '@internationalized/date';

import { currencyString, formatDate } from '@consumer-frontend/nc-utils';

import { NcExpandableListItem } from '../NcExpandableListItem';
import { NcStaticBadgeConfigT, staticBadgeConfigs } from '../NcStaticBadge';

import '@consumer-bootstrap/netcredit.scss';

export type NcScheduledPaymentPropsT = {
  amount: number;
  isAutopay: boolean;
  isPaymentPending: boolean;
  targetDate: DateValue;
};

export type NcScheduledPaymentT = React.FC<NcScheduledPaymentPropsT>;

export const NcScheduledPayment: NcScheduledPaymentT = ({
  amount,
  isAutopay,
  isPaymentPending,
  targetDate,
}) => {
  const badgeConfig = (): NcStaticBadgeConfigT | undefined => {
    if (isPaymentPending && isAutopay) return staticBadgeConfigs.AUTOPAY_PENDING;
    if (isAutopay && !isPaymentPending) return staticBadgeConfigs.AUTOPAY;
    if (isPaymentPending && !isAutopay) return staticBadgeConfigs.PAYMENT_PENDING;

    return undefined;
  };

  return (
    <NcExpandableListItem
      chromaticIgnoreTitle
      title={formatDate(targetDate)}
      body={`${currencyString(amount)} Payment`}
      badgeConfig={badgeConfig()}
    />
  );
};
